module.exports = __webpack_public_path__ + "img/food-26.5372e9e2.jpg";